import DepositInstantAccessSettings from "@/models/Products/ProductSettings/DefaultSettings/InstantAccess/DepositInstantAccessSettings";
import CurrencyUtils from "@/lib/currencyUtils";

export default class UpdateDepositInstantAccessSettings extends DepositInstantAccessSettings {
    updatedAt: Date;

    public constructor(settings: DepositInstantAccessSettings, updatedAt: Date, defaultWalletCurrency: string) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.fundingWindowPeriodType = settings.fundingWindowPeriodType;
            this.fundingWindowPeriodValue = +settings.fundingWindowPeriodValue;
            this.initialDepositWindowPeriodType = settings.initialDepositWindowPeriodType;
            this.initialDepositWindowPeriodValue = +settings.initialDepositWindowPeriodValue;
            this.minimumBalance = settings.minimumBalance;
            this.minimumBalance.amount = CurrencyUtils.convertDecimalStringToAmountString(this.minimumBalance.amount);
            this.minimumBalance.currency = defaultWalletCurrency;
            this.maximumBalance = settings.maximumBalance;
            this.maximumBalance.amount = CurrencyUtils.convertDecimalStringToAmountString(this.maximumBalance.amount);
            this.maximumBalance.currency = defaultWalletCurrency;
        }
    }
}